import React from 'react';
import styles from './DescribeSection.module.css';
import image from './images/TurnAction.png';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const DescribeSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <img src={image} alt="describe" className={styles.image} />
            <div>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    Turn Insight into
                    <br /> Action
                </OptimizedMotionH1>
                <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                    Dashboards connect voice metrics (tone, sentiment, key phrases) with business
                    outcomes (CTR, conversions, watch‑time). Granular filters let you slice by
                    channel, audience segment, or product line, so the social team and the brand
                    team speak the same data language. Automated alerts flag anomalies the moment
                    they appear—before one off‑brand post snowballs.
                </OptimizedMotionP>
            </div>
            <div className={styles.blur}></div>
        </div>
    );
};

export default DescribeSection;
